import { useState, useCallback } from 'react'
import { MediaItemType } from 'src/model/media-directory'
import URLs from 'src/api/url'
export const useMediaItems = setImageURL => {
  const [items, setItems] = useState([])

  const handleSelect = useCallback(
    item => {
      const itemObject = {
        ...item[0],
        url: `${URLs.STORAGE}${item.url}`,
        type: 1,
      }

      if (setImageURL) {
        setImageURL(`${itemObject.url}`)
      }

      setItems([itemObject])
    },
    [setImageURL],
  )

  const addItem = useCallback(
    (url, type = 1) => {
      const finalUrl =
        url && (url.includes('http://') || url.includes('https://'))
          ? url
          : `${URLs.STORAGE}${url}`

      if (setImageURL) {
        setImageURL(finalUrl)
      }

      const item = {
        id: Date.now(),
        url: finalUrl,
        link: finalUrl,
        type,
      }

      setItems([item])
    },
    [setImageURL],
  )

  return { items, handleSelect, addItem }
}
